module.exports = function getResource(label, vars = []) {
    const resources = {
        challengerOneHeader: `Envie d’accumuler ${vars[0]} points?`,
        challengerOneMessage: 'Ouvrez une session pour les enregistrer pour cet achat.',
        challengerTwoHeader: 'Envie de la livraison gratuite?',
        challengerTwoMessage: 'Ouvrez une session pour profiter de la livraison gratuite pour cet achat.',
        signInText: 'Ouvrir une session'
    };

    return resources[label];
};
